import * as React from 'react'

import styles from './FeedbackForm.css'

function FeedbackFormSection({
  title,
  text,
  children,
}: {
  title?: string
  text?: string
  children?: React.ReactNode
}) {
  return (
    <div className={styles.section}>
      {title ? <p className={styles.subtitle}>{title}</p> : null}
      {text ? <p className={styles.text}>{text}</p> : null}
      {children}
    </div>
  )
}

export default React.memo(FeedbackFormSection)
